import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {isMobile} from 'react-device-detect';
import Config from '../../../Config';
import {prepareNewWindowUrl} from '../../../utilities/StringHelpers/StringHelpers';
import {DomainMarketCode, getMarketCode} from 'app/utilities/domain/domainConstants';

const AbroadContactInfoBlock = (props) => {
  const whatsAppUrl = `${Config.staticWebSiteUrl}/clm/5/79/`;
  const contactPhone = window.Config.numberCallCenterAbroad;

  return (
    <div className='contact-us-wrapper'>
      <div className='contact-us'>
        {!isMobile ? (
          <span className='contact-us-main-title'>אנחנו זמינים 24/7 בשיחת חינם מהארץ ומחו״ל</span>
        ) : (
          <div>
            <div className='contact-us-main-title'>אנחנו זמינים 24/7</div>
            <div className='contact-us-main-title'>בשיחת חינם מהארץ ומחו״ל</div>
          </div>
        )}
        <div className='contact-us-phone'>
          {!isMobile ? (
            <div className='contact-us-phone-mobile'>
              <Image src={require('./images/icon_phone.svg')} alt='phone-icon' />
              <span className='contact-us-phone-txt'>התקשרו עכשיו {contactPhone} </span>
            </div>
          ) : (
            <div
              className='contact-us-phone-mobile'
              onClick={() => prepareNewWindowUrl(`tel:${Config.numberCallCenterAbroad.replace('-', '')}`, props.context)}>
              <Image src={require('./images/icon_phone.svg')} alt='phone-icon' />
              <span className='contact-us-phone-txt-mobile'>התקשרו עכשיו {contactPhone}</span>
            </div>
          )}
        </div>
        <div className='contact-us-wa'>
          <span className='contact-us-wa-txt'>או ב-</span>
          <span onClick={() => prepareNewWindowUrl(whatsAppUrl, props.context)} className='contact-us-wa-link'>
            WhatsApp
          </span>
          <Image
            onClick={() => prepareNewWindowUrl(whatsAppUrl, props.context)}
            src={require('./images/icon_wa.svg')}
            alt='wa-icon'
            className='contact-us-wa-icon'
          />
        </div>
      </div>
    </div>
  );
};

export default AbroadContactInfoBlock;
